import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Projectgoal() {
  return (
    <section className="p-100 bg_textcolor" style={{ background: "#000" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Introduction</h2>
            <p>
              Rodeo Social stands as an efficiently interactive platform in the
              realm of social media management. This multi-platform scheduling
              app empowers businesses and teams to seamlessly manage, schedule,
              and post content across various social media platforms. With a
              user-friendly interface, Rodeo Social enables team collaboration
              for content approval and even adds a touch of gamification to the
              social media strategy.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Projectgoal;
